import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { CTA, DesktopOnly, ReadMore, Responsive, P } from 'ui/acro'

const Description = ({ description }) => (
  <Fragment>
    <CTA pb={['11px', null, '10px']} color='grey6'>
      Description
    </CTA>
    <DesktopOnly>
      <P>{description}</P>
    </DesktopOnly>
    <Responsive show={[true, true, false]}>
      <ReadMore id='plan_description_readmore'>
        <P>{description}</P>
      </ReadMore>
    </Responsive>
  </Fragment>
)

Description.propTypes = {
  description: PropTypes.string
}

export default Description
